import { all } from "redux-saga/effects";
import airlines from "./airlines";
import application from "./application";
import countries from "./countries";
import currencies from "./currencies";
import flightDetails from "./flightDetails";
import itineraryDetails from "./itineraryDetails";
import news from "./news";
import travelerTracker from "./travelerTracker";
import user from "./user";
import widgets from "./widgets";

function* allSagas() {
  yield all([
    airlines(),
    application(),
    countries(),
    currencies(),
    flightDetails(),
    itineraryDetails(),
    news(),
    travelerTracker(),
    user(),
    widgets(),
  ]);
}

export default allSagas;
